import React, { useState } from 'react';
import { Modal } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useMutation } from 'hooks/apollo';

import SurveyGroupSelect from 'components/SurveyGroupSelect';

import messages from '../messages';

import connectMutation from './connect.gql';

const ConnectSurveyModal = ({ customerId, surveyId, surveyGroupId, open, onCancel, onDone }) => {
  const [selectedSurveyGroupId, setSelectedSurveyGroupId] = useState();

  const [connect, { loading }] = useMutation(connectMutation);

  const onOk = async () => {
    await connect({ variables: {
      targetSurveyId: surveyId,
      selectedSurveyGroupId,
    } });

    onDone();
  };

  return (
    <Modal
      title={<FormattedMessage {...messages.connectExistingSurvey} />}
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      confirmLoading={loading}
    >
      <SurveyGroupSelect customerId={customerId} onChange={id => setSelectedSurveyGroupId(id)} value={selectedSurveyGroupId} exclude={[surveyGroupId, surveyId]} />
    </Modal>
  );
};

export default ConnectSurveyModal;
